import { render } from "./BasicInfo.vue?vue&type=template&id=dffe9438&scoped=true"
import script from "./BasicInfo.vue?vue&type=script&lang=js"
export * from "./BasicInfo.vue?vue&type=script&lang=js"

import "./BasicInfo.vue?vue&type=style&index=0&id=dffe9438&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-dffe9438"

export default script